/* 

  pixelValue: number or object
  i) number [value] :
    pixelValue: number

    eg: pixelValue: 5                           --->   value === 5

  ii) object [range] :
    pixelValue: {
      min: default exclusive
      max: default inclusive
      minInclusive: default false
      maxInclusive: default true
    }

    eg: { min: 0, max: 5 }                      --->  value > 0 &&  value <= 5
        { min: 0, max: 5, minInclusive: true }  --->  value >= 0 &&  value <= 5
        { min: 0, max: 5, maxInclusive: False } --->  value > 0 &&  value < 5
        { min: 0 }                              --->  value > 0
        { max: 5 }                              --->  value <= 5

*/

export default {
  Vegetation: [
    {
      bg_color: '#de3421',
      legend: 'No (-1 to 0.2)',
      inference: 'No Vegetation.',
      pixelValue: { min: -1, max: 0.2 }
    },
    {
      bg_color: '#f5df1d',
      legend: 'Sparse (0.2 to 0.4)',
      inference: 'Sparse Vegetation.',
      pixelValue: { min: 0.2, max: 0.4 }
    },
    {
      bg_color: '#c5ed40',
      legend: 'Moderate (0.4 to 0.6)',
      inference: 'Moderate Vegetation.',
      pixelValue: { min: 0.4, max: 0.6 }
    },
    {
      bg_color: '#55b52b',
      legend: 'Dense (0.6 to 0.8)',
      inference: 'Dense Vegetation.',
      pixelValue: { min: 0.6, max: 0.8 }
    },
    {
      bg_color: '#156304',
      legend: 'Very Dense (0.8 to 1.0)',
      inference: 'Very Dense Vegetation.',
      pixelValue: { min: 0.8, max: 1 }
    }
  ],
  'Slope Direction': [
    {
      bg_color: '#808080',
      legend: 'Flat Surface',
      inference: 'Flat surface.',
      pixelValue: -1
    },
    {
      bg_color: '#de3421',
      legend: 'North',
      inference: 'Downhill slope faces towards North direction.',
      pixelValue: { min: 0, max: 22.5, minInclusive: true }
    },
    {
      bg_color: '#f26d00',
      legend: 'Northeast',
      inference: 'Downhill slope faces towards Northeast direction.',
      pixelValue: { min: 22.5, max: 67.5 }
    },
    {
      bg_color: '#fff400',
      legend: 'East',
      inference: 'Downhill slope faces towards East direction.',
      pixelValue: { min: 67.5, max: 112.5 }
    },
    {
      bg_color: '#60b000',
      legend: 'Southeast',
      inference: 'Downhill slope faces towards Southeast direction.',
      pixelValue: { min: 112.5, max: 157.5 }
    },
    {
      bg_color: '#00e8f0',
      legend: 'South',
      inference: 'Downhill slope faces towards South direction.',
      pixelValue: { min: 157.5, max: 202.5 }
    },
    {
      bg_color: '#0291bd',
      legend: 'Southwest',
      inference: 'Downhill slope faces towards Southwest direction.',
      pixelValue: { min: 202.5, max: 247.5 }
    },
    {
      bg_color: '#0239cf',
      legend: 'West',
      inference: 'Downhill slope faces towards West direction.',
      pixelValue: { min: 247.5, max: 292.5 }
    },
    {
      bg_color: '#9e04b3',
      legend: 'Northwest',
      inference: 'Downhill slope faces towards Northwest direction.',
      pixelValue: { min: 292.5, max: 337.5 }
    },
    {
      bg_color: '#de3421',
      legend: 'North',
      inference: 'Downhill slope faces towards North direction.',
      pixelValue: { min: 337.5, max: 360 }
    }
  ],
  Slope: [
    {
      bg_color: '#156304',
      legend: '0 - 1',
      inference: '0 - 1 Degree Slope.',
      pixelValue: { min: 0, max: 1, minInclusive: true }
    },
    {
      bg_color: '#55b52b',
      legend: '1 - 15',
      inference: '1 - 15 Degree Slope.',
      pixelValue: { min: 1, max: 15 }
    },
    {
      bg_color: '#c5ed40',
      legend: '15 - 25',
      inference: '15 - 25 Degree Slope.',
      pixelValue: { min: 15, max: 25 }
    },
    {
      bg_color: '#f5971d',
      legend: '25 - 35',
      inference: '25 - 35 Degree Slope.',
      pixelValue: { min: 25, max: 35 }
    },
    {
      bg_color: '#de3421',
      legend: '> 35',
      inference: '> 35 Degree Slope.',
      pixelValue: { min: 35 }
    }
  ],
  Elevation: [
    {
      bg_color: '#156304',
      legend: 'Lowest',
      inference: 'Lowest elevation.',
      pixelValue: { min: 0, max: 1500 }
    },
    {
      bg_color: '#4c8a01',
      legend: 'Low',
      inference: 'Low elevation.',
      pixelValue: { min: 1500, max: 2200 }
    },
    {
      bg_color: '#bfdf00',
      legend: 'Medium',
      inference: 'Medium elevation.',
      pixelValue: { min: 2200, max: 3500 }
    },
    {
      bg_color: '#fff400',
      legend: 'High',
      inference: 'High elevation.',
      pixelValue: { min: 3500, max: 4500 }
    },
    {
      bg_color: '#f26d00',
      legend: 'Highest',
      inference: 'Highest elevation.',
      pixelValue: { min: 4500 }
    }
  ],
  'Water Stress': [
    {
      bg_color: '#156304',
      legend: 'No Stress (greater than 0)',
      inference: 'No Stress',
      pixelValue: 1
    },
    {
      bg_color: '#55b52b',
      legend: 'Low Stress (-0.5 to 0)',
      inference: 'Low Stress.',
      pixelValue: 2
    },
    {
      bg_color: '#c5ed40',
      legend: 'Moderate Stress (-1 to -0.5)',
      inference: 'Moderate Stress.',
      pixelValue: 3
    },
    {
      bg_color: '#f5df1d',
      legend: 'High Stress (lesser than -1)',
      inference: 'High Stress.',
      pixelValue: 4
    }
    // {
    //   bg_color: '#f5971d',
    //   legend: 'High',
    //   inference: 'High water stress.',
    //   pixelValue: { min: -1.6, max: -1.4 }
    // },
    // {
    //   bg_color: '#f76a3b',
    //   legend: 'Very High',
    //   inference: 'Very high water stress.',
    //   pixelValue: { min: -1.8, max: -1.6 }
    // },
    // {
    //   bg_color: '#de3421',
    //   legend: 'Extreme',
    //   inference: 'Extreme water stress.',
    //   pixelValue: { max: -2 }
    // }
  ],
  'Fire Incidents': [
    {
      bg_color: '#156304',
      legend: 'Very Low',
      inference: 'Very Low',
      pixelValue: { min: 0, max: 5 }
    },
    {
      bg_color: '#55b52b',
      legend: 'Low',
      inference: 'Low',
      pixelValue: { min: 5, max: 10 }
    },
    {
      bg_color: '#c5ed40',
      legend: 'Moderate',
      inference: 'Moderate',
      pixelValue: { min: 10, max: 20 }
    },
    {
      bg_color: '#f5971d',
      legend: 'High',
      inference: 'High',
      pixelValue: { min: 20, max: 40 }
    },
    {
      bg_color: '#de3421',
      legend: 'Extreme',
      inference: 'Extreme',
      pixelValue: { min: 40 }
    }
  ],
  Stubble: [
    {
      bg_color: '#156304',
      legend: 'Very Low',
      inference: 'Very Low',
      pixelValue: 1
    },
    {
      bg_color: '#55b52b',
      legend: 'Low',
      inference: 'Low',
      pixelValue: 2
    },
    {
      bg_color: '#c5ed40',
      legend: 'Moderate',
      inference: 'Moderate',
      pixelValue: 3
    },
    {
      bg_color: '#f5971d',
      legend: 'High',
      inference: 'High',
      pixelValue: 4
    },
    {
      bg_color: '#de3421',
      legend: 'Extreme',
      inference: 'Extreme',
      pixelValue: 5
    }
  ],
  'Surface Water Extent': [
    {
      bg_color: '#33ccff',
      legend: 'Water Body',
      inference: 'Water Body',
      pixelValue: 1
    }
  ],
  'Forest Cover': [
    {
      bg_color: '#18d708',
      legend: 'Forest',
      inference: 'Forest',
      pixelValue: { min: 0 }
    }
  ],
  'Mangrove Forest': [
    {
      bg_color: '#0066ff',
      legend: 'Mangrove Gain',
      inference: 'Mangrove Gain',
      pixelValue: -1
    },
    {
      bg_color: '#ff3300',
      legend: 'Mangrove Loss',
      inference: 'Mangrove Loss',
      pixelValue: 1
    }
  ],
  'Land Use': [
    {
      bg_color: '#1a5bab',
      legend: 'Water',
      inference: 'Water',
      pixelValue: 1
    },
    {
      bg_color: '#358221',
      legend: 'Trees',
      inference: 'Trees',
      pixelValue: 2
    },
    {
      bg_color: '#87d19e',
      legend: 'Flooded Vegetation',
      inference: 'Flooded Vegetation',
      pixelValue: 3
    },
    {
      bg_color: '#ffdb5c',
      legend: 'Crops',
      inference: 'Crops',
      pixelValue: 4
    },
    {
      bg_color: '#ed022a',
      legend: 'Built Area',
      inference: 'Built Area',
      pixelValue: 5
    },
    {
      bg_color: '#ede9e4',
      legend: 'Bare Ground',
      inference: 'Bare Ground',
      pixelValue: 6
    },
    {
      bg_color: '#c6ad8e',
      legend: 'Rangeland',
      inference: 'Rangeland',
      pixelValue: 9
    }
  ],
  'Tree Cover': [
    {
      bg_color: '#3dd615',
      legend: 'Tree Gain',
      inference: 'Tree Gain',
      pixelValue: 1
    }
  ],
  'Tree Cover Comparison': [
    {
      bg_color: '#3dd615',
      legend: 'Tree Gain',
      inference: 'Tree Gain',
      pixelValue: 1
    },
    {
      bg_color: '#d61515',
      legend: 'Tree Loss',
      inference: 'Tree Loss',
      pixelValue: -1
    }
  ],
  'Agricultural Drought': [
    {
      bg_color: '#fdd49e',
      legend: 'Very Low (40-100)',
      pixelValue: 1
    },
    {
      bg_color: '#fdac76',
      legend: 'Low (30-40)',
      pixelValue: 2
    },
    {
      bg_color: '#f3724e',
      legend: 'Moderate (20-30)',
      pixelValue: 3
    },
    {
      bg_color: '#d7301f',
      legend: 'High (10-20)',
      pixelValue: 4
    },
    {
      bg_color: '#a20000',
      legend: 'Extreme (below 10)',
      pixelValue: 5
    }
  ],
  'Meteorological Drought': [
    {
      bg_color: '#fdd49e',
      legend: 'Extremely Wet (greater than 2)',
      pixelValue: 1,
      unit: 'mm'
    },
    {
      bg_color: '#fdac76',
      legend: 'Severely Wet (1.5 to 2)',
      pixelValue: 2
    },
    {
      bg_color: '#f3724e',
      legend: 'Moderately Wet (1 to 1.5)',
      pixelValue: 3
    },
    {
      bg_color: '#c26b4f',
      legend: 'Near Normal (-1 to 1)',
      pixelValue: 4
    },
    {
      bg_color: '#bd3725',
      legend: 'Moderate drought (-1.5 to -1)',
      pixelValue: 5
    },
    {
      bg_color: '#860200',
      legend: 'Severe drought (-2 to -1.5)',
      pixelValue: 6
    },
    {
      bg_color: '#130000',
      legend: 'Extreme drought (lesser than -2)',
      pixelValue: 7
    }
  ],
  Drought: [
    {
      bg_color: '#fdd49e',
      legend: 'Very Low',
      pixelValue: 0
    },
    {
      bg_color: '#fdac76',
      legend: 'Low',
      pixelValue: { min: 0, max: 5 }
    },
    {
      bg_color: '#f3724e',
      legend: 'Moderate',
      pixelValue: { min: 5, max: 10 }
    },
    {
      bg_color: '#d7301f',
      legend: 'High',
      pixelValue: { min: 10, max: 15 }
    },
    {
      bg_color: '#a20000',
      legend: 'Extreme',
      pixelValue: { min: 15 }
    }
  ],
  'Crop Acreage': [
    {
      bg_color: '#18d708',
      legend: 'Cropland (above 0.45)',
      inference: 'Class 1',
      pixelValue: 1
      // unit: 'ha'
    },
    {
      bg_color: '#e5ff12',
      legend: 'Fallowland (lesser than 0.45)',
      inference: 'Class 2',
      pixelValue: 2
    }
  ],
  'Soil Erosion': [
    {
      bg_color: '#490eff',
      legend: 'Slight (lesser than 5)',
      inference: 'Class 1',
      pixelValue: 1
      // unit: 'ha'
    },
    {
      bg_color: '#12f4ff',
      legend: 'Moderate (5 to 10)',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#12ff50',
      legend: 'High (10 to 20)',
      inference: 'Class 2',
      pixelValue: 3
    },
    {
      bg_color: '#e5ff12',
      legend: 'Very High (20 to 40)',
      inference: 'Class 2',
      pixelValue: 4
    },
    {
      bg_color: '#ff4812',
      legend: 'Severe (greater than 40)',
      inference: 'Class 2',
      pixelValue: 5
    }
  ],
  'Soil Texture': [
    {
      bg_color: '#156304',
      legend: 'Clay',
      inference: 'Class 1',
      pixelValue: 1
    },
    {
      bg_color: '#55b52b',
      legend: 'Silty Clay',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#c5ed40',
      legend: 'Sandy Clay',
      inference: 'Class 3',
      pixelValue: 3
    },
    {
      bg_color: '#f5df1d',
      legend: 'Clay Loam',
      inference: 'Class 4',
      pixelValue: 4
    },
    {
      bg_color: '#f5971d',
      legend: 'Silty Clay Loam',
      inference: 'Class 5',
      pixelValue: 5
    },
    {
      bg_color: '#f76a3b',
      legend: 'Sandy Clay Loam',
      inference: 'Class 6',
      pixelValue: 6
    },
    {
      bg_color: '#de3421',
      legend: 'Loam',
      inference: 'Class 7',
      pixelValue: 7
    },
    {
      bg_color: '#f26d00',
      legend: 'Silty Loam',
      inference: 'Class 8',
      pixelValue: 8
    },
    {
      bg_color: '#0239cf',
      legend: 'Sandy Loam',
      inference: 'Class 9',
      pixelValue: 9
    },
    {
      bg_color: '#9e04b3',
      legend: 'Silt',
      inference: 'Class 10',
      pixelValue: 10
    },
    {
      bg_color: '#00e8f0',
      legend: 'Loamy Sand',
      inference: 'Class 11',
      pixelValue: 11
    },
    {
      bg_color: '#0291bd',
      legend: 'Sand',
      inference: 'Class 12',
      pixelValue: 12
    }
  ],
  'Soil Organic Carbon': [
    {
      bg_color: '#156304',
      legend: 'Very Good',
      inference: 'Class 1',
      pixelValue: { min: 2000 }
    }
  ],
  'Soil Moisture Content': [
    {
      bg_color: '#f6ff0c',
      legend: 'Near Normal (0 to 1)',
      inference: 'Class 1',
      pixelValue: 1,
      unit: 'kg/m^2'
    },
    {
      bg_color: '#ffb808',
      legend: 'Moderate (-0.5 to 0)',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#ff530c',
      legend: 'Low (-1 to -0.5)',
      inference: 'Class 3',
      pixelValue: 3
    },
    {
      bg_color: '#7a0f02',
      legend: 'Very Low (lesser than -1)',
      inference: 'Class 4',
      pixelValue: 4
    },
    {
      bg_color: '#0c08ff',
      legend: 'Very High (greater than 1)',
      inference: 'Class 5',
      pixelValue: 5
    }
  ],
  Soil: [
    {
      bg_color: '#156304',
      legend: '80 to 100% of the growth potential',
      inference: 'Class 1',
      pixelValue: 1
    },
    {
      bg_color: '#55b52b',
      legend: '60 to 80%',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#c5ed40',
      legend: '40 to 60%',
      inference: 'Class 3',
      pixelValue: 3
    },
    {
      bg_color: '#f5df1d',
      legend: '< 40%',
      inference: 'Class 4',
      pixelValue: 4
    },
    {
      bg_color: '#f5971d',
      legend: 'Non Soil',
      inference: 'Class 5',
      pixelValue: 5
    },
    {
      bg_color: '#f76a3b',
      legend: 'Permafrost area',
      inference: 'Class 6',
      pixelValue: 6
    },
    {
      bg_color: '#de3421',
      legend: 'Water bodies',
      inference: 'Class 7',
      pixelValue: 7
    }
  ],
  'Carbon Flux Emission': [
    {
      bg_color: '#ffff00',
      legend: 'Carbon Flux Emission',
      inference: 'Carbon Flux Emission',
      pixelValue: { min: 0, max: 3700 }
    }
  ],
  'Carbon Flux Removal': [
    {
      bg_color: '#ff9933',
      legend: 'Carbon Flux Removal',
      inference: 'Carbon Flux Removal',
      pixelValue: { min: 0, max: 3700 }
    }
  ],
  'Net Carbon Flux': [
    {
      bg_color: '#009933',
      legend: 'Net Carbon Flux',
      inference: 'Net Carbon Flux',
      pixelValue: { min: 0, max: 3700 }
    }
  ],
  'Crop Health': [
    {
      bg_color: '#f6ff0c',
      legend: 'No stress (greater than 0)',
      inference: 'Class 1',
      pixelValue: 1
    },
    {
      bg_color: '#ffb808',
      legend: 'Low stress (-0.5 to 0)',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#ff530c',
      legend: 'Moderate stress (-1 to -0.5)',
      inference: 'Class 3',
      pixelValue: 3
    },
    {
      bg_color: '#7a0f02',
      legend: 'High stress (lesser than -1)',
      inference: 'Class 4',
      pixelValue: 4
    }
  ],
  'Crop Condition': [
    {
      bg_color: '#ff2b04',
      legend: 'No vegetation (lesser than 0) ',
      inference: 'Class 1',
      pixelValue: 1
    },
    {
      bg_color: '#ffc306',
      legend: 'Bare soil (0 to 0.03)',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#fff108',
      legend: 'Sparse vegetation (0.03 to 0.3)',
      inference: 'Class 3',
      pixelValue: 3
    },
    {
      bg_color: '#4eff0e',
      legend: 'Moderate vegetation (0.3 to 0.5)',
      inference: 'Class 4',
      pixelValue: 4
    },
    {
      bg_color: '#22ab0e',
      legend: 'Dense vegetation (greater than 0.5)',
      inference: 'Class 4',
      pixelValue: 5
    }
  ],
  'Crop Classification': [
    {
      bg_color: '#ff2b04',
      legend: 'Cotton',
      inference: 'Class 1',
      pixelValue: 1
    },
    {
      bg_color: '#ffc306',
      legend: 'Wheat',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#55b52b',
      legend: 'Other Crops',
      inference: 'Class 3',
      pixelValue: 3
    }
  ],
  'Water Contamination': [
    {
      bg_color: '#0c08ff',
      legend: 'Clear (lesser than 0.05)',
      inference: 'Class 1',
      pixelValue: 1
      // unit: 'ha'
    },
    {
      bg_color: '#08fffc',
      legend: 'Slightly turbid (0.05 to 0.25)',
      inference: 'Class 2',
      pixelValue: 2
    },
    {
      bg_color: '#4aff08',
      legend: 'Moderately turbid (0.25 to 0.4)',
      inference: 'Class 3',
      pixelValue: 3
    },
    {
      bg_color: '#f6ff08',
      legend: 'Highly turbid (0.4 to 0.6)',
      inference: 'Class 4',
      pixelValue: 4
    },
    {
      bg_color: '#ff4306',
      legend: 'Extremely turbid (above 0.6)',
      inference: 'Class 5',
      pixelValue: 5
    }
  ]
};
